export default __webpack_public_path__ + "static/media/android.88cd239b.png";